/**
 * Placeholder grid for a cold catalog load — no cached copy to paint yet.
 *
 * Each placeholder mirrors ToolCard's box (same padding, same head/title/chips
 * stack) so the grid does not reflow when the real cards land.
 *
 * The placeholders are aria-hidden and one live region carries the meaning:
 * assistive tech should hear "Loading tools" once, not six empty cards.
 */
export function ToolCardSkeleton({ count = 6 }: { count?: number }) {
  return (
    <>
      <p className="sr-only" role="status" aria-label="Loading tools">
        Loading tools…
      </p>
      <div className="catalog__grid" aria-hidden="true">
        {Array.from({ length: count }, (_, i) => (
          <div key={i} className="card card--skeleton">
            <div className="card__head">
              <span className="skeleton skeleton--dept" />
              <span className="skeleton skeleton--icon" />
            </div>
            <span className="skeleton skeleton--title" />
            <div className="chips">
              <span className="skeleton skeleton--chip" />
              <span className="skeleton skeleton--chip" />
            </div>
          </div>
        ))}
      </div>
    </>
  )
}
